export type {YfmMods, YfmStaticViewProps} from './YfmStaticView';
export {YfmStaticView} from './YfmStaticView';
